
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a4f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a4f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("49Vsg", function(module, exports) {

$parcel$export(module.exports, "showLoader", function () { return $30749206cb9ee7e5$export$56525cbb1fcd885c; });
$parcel$export(module.exports, "hideLoader", function () { return $30749206cb9ee7e5$export$5cee2c2772922923; });
parcelRequire("8gnUm");
var $5BcOL = parcelRequire("5BcOL");
const $30749206cb9ee7e5$var$bodyRef = document.querySelector('body');
const $30749206cb9ee7e5$var$loaderRef = document.querySelector('.loader');
function $30749206cb9ee7e5$export$56525cbb1fcd885c() {
    $30749206cb9ee7e5$var$bodyRef?.classList.add('isLoading');
    (0, $5BcOL.showElement)($30749206cb9ee7e5$var$loaderRef);
}
function $30749206cb9ee7e5$export$5cee2c2772922923() {
    $30749206cb9ee7e5$var$bodyRef?.classList.remove('isLoading');
    (0, $5BcOL.hideElement)($30749206cb9ee7e5$var$loaderRef);
}

});
parcelRegister("8gnUm", function(module, exports) {

$parcel$export(module.exports, "showElement", function () { return (parcelRequire("5BcOL")).showElement; });
$parcel$export(module.exports, "hideElement", function () { return (parcelRequire("5BcOL")).hideElement; });

var $5BcOL = parcelRequire("5BcOL");

});
parcelRegister("5BcOL", function(module, exports) {

$parcel$export(module.exports, "hideElement", function () { return $413a59d0d78fd19f$export$7669482c90f5c50f; });
$parcel$export(module.exports, "showElement", function () { return $413a59d0d78fd19f$export$998191bfdf710c72; });
function $413a59d0d78fd19f$export$7669482c90f5c50f(el) {
    el?.classList?.add('isHidden');
    el?.setAttribute('aria-hidden', 'true');
}
function $413a59d0d78fd19f$export$998191bfdf710c72(el) {
    el?.classList?.remove('isHidden');
    el?.setAttribute('aria-hidden', 'false');
}

});




var $49Vsg = parcelRequire("49Vsg");
function $c6262064a2747523$export$2e2bcd8739ae039() {
    const factsContainer = document.querySelector('.metrics__list');
    if (!factsContainer) return;
    const countersConfig = [
        {
            start: 2,
            end: 20,
            step: 1,
            duration: 1000
        },
        {
            start: 4,
            end: 16,
            step: 1,
            duration: 1000
        },
        {
            start: 25328,
            end: 35000,
            step: 204,
            duration: 1000
        },
        {
            start: 4652,
            end: 10000,
            step: 333,
            duration: 1000
        }
    ];
    let intervalIds = []; // Для зберігання інтервалів, щоб їх очищати
    const resetCounters = ()=>{
        const counterElements = factsContainer?.querySelectorAll('.metric__number');
        counterElements?.forEach((el, index)=>{
            el.textContent = countersConfig[index]?.start?.toLocaleString();
        });
    };
    const startCounters = ()=>{
        const counterElements = factsContainer?.querySelectorAll('.metric__number');
        counterElements?.forEach((el, index)=>{
            const { start: start, end: end, step: step, duration: duration } = countersConfig[index];
            const delay = index * 200; // Затримка в 200 мс для кожного наступного
            setTimeout(()=>{
                const intervalId = $c6262064a2747523$var$startCounter(start, end, step, duration, el);
                intervalIds.push(intervalId);
            }, delay);
        });
    };
    // Спостерігаємо за зміною класу
    const observer = new MutationObserver(()=>{
        if (factsContainer?.classList.contains('animate-start')) {
            // Запуск лічильників
            intervalIds?.forEach(clearInterval); // Очистити попередні інтервали, якщо є
            intervalIds = [];
            startCounters();
        } else {
            // Скидання лічильників
            intervalIds?.forEach(clearInterval); // Очистити інтервали
            intervalIds = [];
            resetCounters();
        }
    });
    observer.observe(factsContainer, {
        attributes: true,
        attributeFilter: [
            'class'
        ]
    });
}
function $c6262064a2747523$var$startCounter(startValue, endValue, step, duration, element) {
    const stepsCount = Math.ceil((endValue - startValue) / step);
    const interval = duration / stepsCount;
    let currentValue = startValue;
    const intervalId = setInterval(()=>{
        currentValue += step;
        if (currentValue >= endValue) {
            currentValue = endValue;
            clearInterval(intervalId);
        }
        element.textContent = currentValue?.toLocaleString();
    }, interval);
    return intervalId; // Повертаємо ID інтервалу, щоб можна було його очистити
}


document.addEventListener('DOMContentLoaded', $aa059ef06a9c5f56$var$onDOMContentLoaded);
function $aa059ef06a9c5f56$var$onDOMContentLoaded() {
    (0, $49Vsg.hideLoader)();
    (0, $c6262064a2747523$export$2e2bcd8739ae039)();
}


//# sourceMappingURL=pages.2a37f540.js.map
